import React from 'react'

export default function CommentSendIcon(props) {


    return (
        <>
            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.5">
                    <rect width="19" height="19" rx="5" fill="#377DFF" />
                    <rect width="19" height="19" rx="5" fill="white" fillOpacity="0.8" />
                </g>
                <path d="M6.3046 5.02325L13.8936 8.83555C13.9258 8.85176 13.9527 8.87557 13.9714 8.90449C13.9901 8.93342 14 8.9664 14 9C14 9.0336 13.9901 9.06658 13.9714 9.09551C13.9527 9.12443 13.9258 9.14824 13.8936 9.16445L6.3046 12.9768C6.2733 12.9925 6.23807 13.0005 6.20235 13C6.16664 12.9995 6.13169 12.9905 6.10095 12.9739C6.0702 12.9573 6.04472 12.9336 6.02702 12.9053C6.00932 12.877 6.00001 12.8449 6 12.8123V5.18769C6.00001 5.15507 6.00932 5.12301 6.02702 5.09468C6.04472 5.06635 6.0702 5.04272 6.10095 5.02612C6.13169 5.00952 6.16664 5.00053 6.20235 5.00002C6.23807 4.99952 6.2733 5.00752 6.3046 5.02325ZM6.82212 9.37545V11.8598L12.5153 9L6.82212 6.14021V8.62455H8.87742V9.37545H6.82212Z" fill="#377DFF" />
            </svg>

        </>
    )
}
